import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useRegisterCommandDefinitions } from '@/contexts/CommandRegistryContext';
import { createInvoiceCommands } from '@/src/routes/invoices/index';

export function InvoiceCommands() {
    const navigate = useNavigate();

    const commands = React.useMemo(
        () => createInvoiceCommands(navigate),
        [navigate]
    );

    useRegisterCommandDefinitions(commands);

    return null;
}